module.exports = __webpack_public_path__ + "static/img/xjp.efd5d3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xjp.png
// module id = 7qmn
// module chunks = 0